import { Link } from 'react-router-dom';
import type { Category } from 'TYPES/api.body';
import { normalizeCategoryLogoUrl, resolveLandingCategories } from 'utils/landingCategories';

interface Props {
  categories: Category[];
}

const BlobGrid: React.FC<Props> = ({ categories }) => {
  const landingCategories = resolveLandingCategories(categories);

  return (
    <div className="flex justify-center gap-8 py-10 padding-section">
      {landingCategories.map(category => {
        const apiCategory = categories.find(item => item.id === category.id);
        const apiLogo = normalizeCategoryLogoUrl(apiCategory?.logo);
        const imageSrc = apiLogo ?? category.image;

        return (
          <div key={category.slug} className="flex flex-col items-center group">
            <Link
              className="flex flex-col items-center"
              to={`/categories/${category.slug}?category=${category.id}`}>
              <div className="mb-2 w-full flex justify-center overflow-hidden rounded-lg">
                <img
                  src={imageSrc}
                  alt={category.name}
                  className="max-w-[180px] w-full h-auto object-contain transition-transform duration-300 ease-in-out group-hover:scale-110"
                  onError={event => {
                    const target = event.currentTarget;
                    if (target.src !== category.fallbackImage) {
                      target.src = category.fallbackImage;
                    }
                  }}
                />
              </div>
            </Link>
          </div>
        );
      })}
    </div>
  );
};

export default BlobGrid;
